import * as React from 'react';
import { Colors } from '@estee/elc-base-theme';
import styled from 'styled-components';
import * as classnames from 'classnames';

export interface IIconProps {
    className: string;
    size: string;
    width?: number;
    height?: number;
    image?: string;
    color?: string;
    background?: string;
    transform?: string;
    'aria-label'?: string;
}

interface ISizes {
    [key: string]: number;
}

export const SIZES: ISizes = {
    xsmall: 10,
    small: 16,
    medium: 20,
    large: 24,
    xlarge: 60,
    xxlarge: 90
};

const IconPlaceholder = styled.div`
    cursor: pointer;
    width: ${props =>
        props.theme.size !== 'custom' ? SIZES[props.theme.size] : props.theme.width}px;
    height: ${props =>
        props.theme.size !== 'custom' ? SIZES[props.theme.size] : props.theme.height}px;
    transform: ${props => (props.theme.transform ? props.theme.transform : '')};
`;

const MaskIconPlaceholder = styled(IconPlaceholder)`
    background-color: ${props => (props.theme.color ? props.theme.color : Colors.black)};
    mask: ${props => props.theme.image && props.theme.image} no-repeat center;
`;

const BackgroundIconPlaceholder = styled(IconPlaceholder)`
    background: ${props => props.theme.background && props.theme.background} no-repeat center;
`;

const Icon = (props: IIconProps) => {
    const { className, 'aria-label': ariaLabel, ...theme } = props;
    const genericIconClassname = 'elc-icon js-icon';

    return theme.image ? (
        <MaskIconPlaceholder
            className={classnames(className, genericIconClassname)}
            theme={theme}
            aria-label={ariaLabel}
        />
    ) : (
        <BackgroundIconPlaceholder aria-label={ariaLabel} className={className} theme={theme} />
    );
};

export { Icon };
